import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

/** This is leftover after Rafal. He was too lazy to check how to generate error messages */
export const voucherErrorMessage = createSelector(
    onlineOrderState,
    onlineOrder => [(onlineOrder.voucherRequest.error?.error?.Message || '')]
);
